/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import CalendarService from '@/services/CalendarService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Rightbar/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getEventsByType = handler(
  'getEventsByType',
  CalendarService.getEventsCalendar
);

export const getAllEvents = handler(
  'getAllEvents',
  CalendarService.getEventsCalendar
);
